import { useState } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import ScheduleDetailsDrawer from '../../../components/drawers/scheduleDetailsDrawer/ScheduleDetailsDrawer';
import { ReactComponent as Train } from '../../../../../resources/images/svg/train.svg';
import { ReactComponent as DownArrow } from '../../../../../resources/images/svg/downArrow.svg';

function ScheduleListMobileItem({ schedule, stationsMap }) {
  const [showDrawer, setShowDrawer] = useState(false);

  return (
    <div>

      <div className="flex flex-col gap-2 lg:hidden pl-4">
        <p className="text-base m-0 flex-[2] capitalize flex items-center gap-2">
          {stationsMap.get(schedule?.startStation?.code) || schedule?.startStation?.name}
          {' '}
          <ArrowRightOutlined
            style={{ color: 'var(--primary-color)', fontSize: '16px' }}
          />
          {' '}
          {stationsMap.get(schedule?.endStation?.code) || schedule?.endStation?.name}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex gap-2">
            <p className="text-xl m-0">
              {moment(schedule?.startDate).format('HH:mm')}
            </p>
            <p className="text-xl m-0">-</p>
            <p className="text-xl m-0">
              {moment(schedule?.endDate).format('HH:mm')}
            </p>
          </div>
          <button
            type="button"
            onClick={() => setShowDrawer(schedule)}
            className="flex gap-3 items-center px-2 h-8 border-transparent bg-white rounded-2xl cursor-pointer"
          >
            <Train />
            <p className="text-xl m-0 ">
              #
              {schedule?.rideNumber}
            </p>
            <DownArrow className="rotate-[0deg]" />
          </button>
        </div>

      </div>
      <div className="w-full h-[2px] bg-white mt-2" />
      <ScheduleDetailsDrawer stationsMap={stationsMap} show={showDrawer} setShow={setShowDrawer} />
    </div>
  );
}

export default ScheduleListMobileItem;
